import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { AuthGuard, P404Component, P403Component, LoginComponent } from '@resultsgate-ui/shared'
import { DashboardComponent } from './dashboard/dashboard.component'

export const routes: Routes = [
    {
        path: '404',
        component: P404Component,
        data: {
            title: 'Page 404',
            shell: false,
        },
    },
    {
        path: '403',
        component: P403Component,
        data: {
            title: 'Page 403',
            shell: false,
        },
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            title: 'Login Page',
            shell: false,
            hideInfo: true,
        },
    },

    {
        path: '',
        pathMatch: 'full',
        data: { roles: ['admin'], breadcrumb: 'menu.home' },
        component: DashboardComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
    },
    {
        path: 'orders',
        data: { roles: ['admin'], breadcrumb: 'menu.orders' },
        loadChildren: () => import('./orders/orders.module').then((m) => m.OrdersModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
    },
    {
        path: 'samples',
        data: { roles: ['admin'], breadcrumb: 'menu.samples' },
        loadChildren: () => import('./samples/samples.module').then((m) => m.SamplesModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
    },
    {
        path: 'customers',
        data: { roles: ['admin'], breadcrumb: 'menu.customers' },
        loadChildren: () => import('./customers/customers.module').then((m) => m.CustomersModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
    },
    {
        path: 'surveys',
        data: { roles: ['admin'], breadcrumb: 'menu.surveys' },
        loadChildren: () => import('./surveys/surveys.module').then((m) => m.SurveysModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
    },
    {
        path: 'analyses',
        data: { roles: ['admin'], breadcrumb: 'menu.analyses' },
        loadChildren: () => import('./analyses/analyses.module').then((m) => m.AnalysesModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
    },
    {
        path: 'results',
        data: { roles: ['admin'], breadcrumb: 'menu.results' },
        loadChildren: () => import('./results/results.module').then((m) => m.ResultsModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
    },
    {
        path: 'samplingmethods',
        data: { roles: ['admin'], breadcrumb: 'menu.samplingMethods' },
        loadChildren: () => import('./samplingmethods/samplingmethods.module').then((m) => m.SamplingmethodsModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
    },
    {
        path: 'categories',
        data: { roles: ['admin'], breadcrumb: 'menu.categories' },

        loadChildren: () => import('./categories/categories.module').then((m) => m.CategoriesModule),
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
    },
    { path: 'calendar', loadChildren: () => import('./calendar/calendar.module').then((m) => m.CalendarModule) },

    { path: '**', component: P404Component, data: { shell: false } },
]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
